import { render } from "./MeusDados.vue?vue&type=template&id=e551b7ee"
import script from "./MeusDados.vue?vue&type=script&lang=js"
export * from "./MeusDados.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__